import React from 'react';
import { useNavigate } from 'react-router-dom';

function Agradecimento() {
  const navigate = useNavigate();

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '80vh', 
      padding: '20px',
      fontFamily: 'sans-serif',
      textAlign: 'center'
    }}>
      
      {/* Ícone de Sucesso Animado ou Estático */}
      <div style={{ 
        fontSize: '80px', 
        color: '#28a745', 
        marginBottom: '20px' 
      }}>
        ✅
      </div>

      <h1 style={{ color: '#FDBB20', marginBottom: '10px' }}>Obrigado!</h1>
      
      <p style={{ fontSize: '18px', color: '#555', maxWidth: '600px', marginBottom: '40px' }}>
        Suas respostas foram enviadas com sucesso. Agradecemos a sua colaboração.
      </p>

      {/* Botão de Voltar com Seta */}
      <button 
        onClick={() => navigate(-1)} // Volta para a página anterior
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: '12px 24px',
          backgroundColor: '#333',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          fontSize: '16px',
          cursor: 'pointer',
          fontWeight: 'bold',
          transition: 'background 0.3s'
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = '#555'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#333'}
      >
        <span>⬅</span> Voltar para o Início
      </button>

    </div>
  );
}

export default Agradecimento;